export default [
  { name: '來電洽詢', imgSrc: '', subTitle: '', section: 'contact-info', svgSrc: '' },
  { name: '地圖導航', imgSrc: '', subTitle: '', section: 'contact-info', svgSrc: '' },
  { name: '立即預約', imgSrc: '', subTitle: '', section: 'contact', svgSrc: '' },
]
